/* eslint-disable quotes */
// Inglês
export const ingles = {
  start: "Start",
  save: "Save",
  delete: "Delete",
  update: "Update",
  lets: "Let’s Play",
  permanentbuy: "Permanent Buy",
  signature: "Monthly Signature",
  weekly: "Weekly Signature",
  signatureano: "Annual Subscription",
  male: "Male  ",
  female: "Female",
  ambos: "Both",
  time: "Time",
  choosecategory: "Choose the category",
  categories: "Categories",
  light: "Light",
  preliminary: "Preliminary",
  oral: "With Mouth",
  anal: "Backdoor",
  hot: "Hot",
  extreme: "Extreme",
  vd: "Truth",
  dare: "Dare",

  truth: "Truth",
  createMyChallenges: "Create My Challenges",
  chosen: "Chosen",
  text3: "Let love flow in you!",
  text4: "Get ready to live intensely ",
  close: "Close",
  dev: "Developed by Dev12BR",
  next: "NEXT",
  config3: "No ads",
  config4: "Choose avatars to upgrade",
  config9: "Create and edit your own challenges",
  version: "Premium Version",
  alert3: "Please select at least one category",
  tituloAlert1: "⚠️ The game is about to start 😜",
  duvidas: "Doubts or Suggestions - Spicy Challenges",
  description: "Hello, my question or suggestion is :",
  send: "Send",
  contact: "Contact",
  botaoApple: "Restore purchases",
  alertCompra: "Your purchase is being restored",
  NotPurchase: "You don\\'t have any purchases.",
  options: "Options",
  avalie: "Rate",
  novaCategoria: "My Categories",
  alterLanguage: "Change the language?",
  textLanguage: "When selecting a new language, the application will restart.",
  textLanguage1: "Switch language",
  cancel: "Cancel",
  languages: "Languages",
  deletCat: "Delete category",
  textDeletCat:
    "When deleting this category, the challenges present in this category will be deleted. After this action it can no longer be undone.",
  deletDes: "Delete the challenge",
  textDeletDes:
    "After deleting the challenge this action can no longer be undone.",
  desafio: "Register New Challenge",
  desafiotexto: "Challenge",
  textoeditDesafio: "Who can do this?",
  textEmquem: "Who ?",
  nome: "Name",
  inicio: "Start game",
  inicio9: "Help",
  cadastrarCategory: "Add New Category",
  inicio15: "Creating a new category",
  inicio16:
    "Step 1 : Press the button with the sign of + that is located in the inferior part of this screen. After pressing, a Window will appear to enter your new category.",
  inicio17: "Step 2 : Enter your new category and click save",
  inicio18:
    "Step 3 : To edit, delete or ADD CHALLENGES within the category, press your finger on it. (Button with your category).",
  inicio19:
    "On the next screen, pressing the button indicated with the arrow ⬆️, a window will open for editing your new category.",
  inicio20:
    "Step 5: On the next screen, pressing the button indicated with the arrow ⬆️, you will delete the category.",
  inicio21:
    "Step 1: Click the button below to add a new challenge to this category",
  inicio22: "Creating a new challenge",
  inicio23:
    "Step 2: Click on each circled item to know in detail each registration field",
  inicio24: "Challenge Text",
  inicio25: `Write the challenge to your liking, and for the name of the player to be displayed in the challenge, just press the red button below. 
    
It will add following characters {nome}. 

** DO NOT CHANGE THESE CHARACTERS ** For the name to be displayed accordingly, it needs to be as described below ⬇️⬇️⬇️⬇️

Challenge: Kiss the neck of {nome}`,
  inicio26: "Who can do, and who can receive",
  inicio27: `Select "Both" if the challenge can be run and received by participants of "both" genres.
  
If the challenge is directed to a genre, just select the desired one
`,
  inicio28: "Adding Time to Challenge",
  inicio29:
    'In case your challenge has a time, just drag the "range" below, and the value will be displayed above. After the timer expires in the challenge, a sound will play announcing that the challenge is over.',
  aviso12: `Here you create only the category!!
    
To add the challenges, just press the button of your category that was just created ⬆️⬆️⬆️⬆️`,
  voltar: "Return",
  semDe: "Player without challenges",
  semDe2: `Register at least one challenge for this player 😬.
  
You will be redirected to the login screen.`,
  term: "Privacy",
  Potitic: "Terms of use",
  adquirited: "Purchased",
  config10: "Exclusive category",
  config11: "800+ new challenges",
  camera: "Camera",
  galery: "Gallery",
  avatar: "Avatars",
  image: "Picture",
  seletion: " Selected",
  editCategory: "Edit Category",
  frase1: "Are you enjoying the challenges ?",
  frase2: "How about trying the Premium Challenges ?",

  errTexto:
    "If you have found a translation error, please correct the sentence in the field below:",
  errTitulo: "Notice something wrong?",
  errCorrect: "How would it be in English?",
  thisLanguageIsCorrect: "Is the challenge in ENGLISH correct?",
  yes: "Yes",
  no: "No",

  errSend: "Send suggestion",

  share: "Share",
  fraseShare: `What a Top app! Just sharing because I know you'll like it too!
  Download it and then tell me if it's not too good lol...😉
  
  
  Link for download: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇺🇸",

  morePlayer: "Play with more players ?",
  players: "Players",
  carregar: "Upload Image",
  takePhoto: "Take a picture or select an image",
  useAvatar: "Or use Avatars",

  hetero: "Straight",
  gay: "Gay",
  lesbico: "Lesbian",

  nomeHomem1: "Man's Name",
  nomeHomem2: "Man's Name",
  nomeMulher1: "Woman's Name",
  nomeMulher2: "Woman's Name",
  messageErr: "Add the players 🙌",
  descricaoErr: "Enter the names of the participants ✍️",
  why: "Tell us why...",
  later: "Evaluate Later",
  txtCard1: "Your turn 🔥",
  txtCard2: "Make it happen 😘",
  txtCard3: "Come on! 😜",
  txtCard4: "Next challenge 😈",
  txtCard5: "One more! 👄",

  tituloBloco1Novo: "Strengthen Your Bond Together",
  subtitulo1Novo: "Join over 2 million happy couples!",
  texto1Novo:
    "Discover exciting games designed to bring you closer to your partner. Unlock all categories now and experience new levels of intimacy, fun, and connection!",

  tituloBloco2Novo: "New adventures, deeper love.",
  texto2Novo1: "Enjoy over 1,500 challenges",
  texto2Novo2: "Create your own unique challenges",
  texto2Novo3: "Exclusive categories",
  texto2Novo4: "Ad-free experience",
  texto2Novo5: "Exclusive Avatars",
  texto2Novo6: "Discover new challenges daily",
  texto2Novo7: "Regularly updated games",
  tituloBloco3Novo: "Top-rated in this category",
  tituloBloco4Novo: "Enhance your relationship with:",
  texto4Novo1: "Intimacy",
  texto4Novo2: "Desire",
  texto4Novo3: "Lighthearted moments",
  texto4Novo4: "Attraction",
  texto4Novo5: "Connection",
  texto4Novo6: "Pleasure",

  tituloBloco5Novo: "What couples are saying",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1: `I think this is the best app I've found on mobile so far as hot and interesting all the other apps I've seen can't compare so get a job and buy it. Don't complain because your broke. Your missing out on some really good things here and $10.00 to own the whole app. It offers better experiences then games you get at the local pleasure stores.`,
  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "This app is amazing! I was in doubt whether or not I should download it, but it was certainly the best feeling we've had in recent times. How good it is to know that we can still do many things together. 🤭 We tested the paid version and it's really worth it, we hadn't reached that level of pleasure yet.",
  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "If you want to spice up the relationship this app is perfect! I had already tested others but none pleased us like this one. Our foreplay was much hotter and more pleasurable (now imagine the rest!) It's really worth buying the paid version (if you want to feel a more intense pleasure) but the free version surprised you too.",
  texto5depoimentoTitulo4: "Anne owens",
  texto5depoimento4:
    "Excellent! Very good indeed... We got very horny during the game which made the sex much more gripping, it was pleasure everywhere! We're already looking forward to playing again 💦🔥 we also recommend the paid version if you guys can handle the horny 🤤",

  tituloBloco6Novo:
    "Do like hundreds of couples around the world and spice up your relationship. Discover more than 800 new challenges!",
  texto6Select: "Choose the version:",
  texto6Premium: "Premium",
  texto6Assinatura: "Subscription",
  texto6Semanal: "Weekly",
  texto6Mensal: "Monthly",
  texto6Anual: "Annual",
  texto6Vitalicia: "Lifetime license",
  bePremium: "Unlock Premium Today",
  buyNew: "Get Started",
  attention: "Attention!",
  changeGender: "You have changed your sexual orientation",

  tituloAvaliacao: "Enjoying the game?",
  textoAvaliacao: "Rate it and help us keep improving!",
  agoraNão: "Not now",
  enviarAvaliacao: "Send",

  nomeJogo1: "Hot Challenges",
  nomeJogo2: "Truth or Dare",
  nomeJogo3: "Dirty Levels",
  nomeJogo4: "Naughty Roulette",
  nomeJogo5: "Quote of the Day",
  naughtyQuiz: "Naughty Quizz",

  playAlone: "Solo Challenges",
  estaSozinho: "Playing alone?",
  selectPlayer: "Select Player",

  skip: "Skip",
  responder: "Send",
  respondaAqui: "Answer here",
  config4: "Choose avatars for customization",

  tituloSelect1: "Playing alone?",
  tituloSelect2: "Answer daring questions!",

  subTituloSelect1: "We'll give you a hand!",
  subTituloSelect2: "Discover how naughty you are!",
  txtJogador1:
    "Select your player and explore guided solo pleasures designed just for you!",
  txtJogador2: "The selected player will answer the questions",
  tituloCena: "WHICH ITEMS WOULD YOU LIKE TO USE?",
  subTituloCena:
    "Don't have one? Tap 'Get' and purchase it from the partner store.",
  play: "Play",

  titleUserWarning: "Choose a user",
  txtUserWarning: "Select a user to answer the questions",

  shareNivelDeSafadeza:
    "Hey, check out my naughtiness level 😈 Experience intense moments of pleasure. You should try it too 💋 Download the app now and get ready to enjoy spicy challenges 🔥 with your partner!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Transform your love life right now! Download the app and discover the secret to a spicy relationship: ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "You are a modest person, not very into naughtiness, and prefer something more romantic!",
  resultadoQuiz2:
    "You are too romantic to indulge in naughtiness, and you enjoy a candlelit atmosphere more.",
  resultadoQuiz3:
    "You are a rather reserved person and believe in keeping things more discreet and private in your intimate life.",
  resultadoQuiz4: `That doesn't mean you're not naughty sometimes, but you prefer to save all that fire to spend it with someone very special.`,
  resultadoQuiz5: `Your warmth is in the background, but that doesn't change the fact that there is warmth!`,
  resultadoQuiz6:
    "You like to explore new experiences, but always with respect and consent.",
  resultadoQuiz7: `You love a hot date, full of kisses and lots of action. However, there's a side of you that also enjoys watching a movie while holding your crush's hand or having a candlelit dinner.`,
  resultadoQuiz8: `You're willing to try new and exciting things, but always responsibly.`,
  resultadoQuiz9: `You're a bold person and like to spice things up in your intimate life from time to time.`,
  resultadoQuiz10:
    "You enjoy all the pleasures of life and have no limits when it comes to sex.",
  resultadoQuiz11: `With you, there's no bad time, and it's always time for a quickie! A romance movie? Only if it's "50 Shades of Grey"!`,
  resultadoQuiz12: `For you, intimacy is a constant adventure, and you're not afraid to take risks.`,
  mes: "Month",
  desafiosRestantesDois: "You have 2 Premium challenges remaining!",
  nenhumDesafioRestante: "No more Premium challenges left!",
  tornePremiumAviso1: "Go Premium now and enjoy 1000 Exclusive challenges!",
  tornePremiumAviso2:
    "Enjoy unlimited challenges, exclusive content, and uninterrupted fun!",
  conteudoPremium: "You've selected Premium content!",
  aproveite4desafios:
    "Enjoy 4 premium challenges to experience exclusive pleasure.",

  calculando: "Calculating Results...",
  nivelRomantismo: "Your level of naughtiness is...",
  finalizar: "Finish",
  erroQuizTitulo: "Enter your answer",
  erroQuizFrase: "To proceed, enter your answer!",
  new: "NEW APP",

  //resposta quiz safadeza
  resQuiz1: "Gentle",
  resQuiz2: "Passionate",
  resQuiz3: "Charming",
  resQuiz4: "Super naughty",

  tempSemanal: "Billed weekly",
  tempMensal: "Billed monthly",
  tempAnual: "Billed annually",
  tempSempre: "One-time payment",
  canceleAny: "Cancel anytime",

  //Tela do safadrometro
  Low: "Low",
  Medium: "Medium",
  High: "High",
  lifeTime: "Lifetime access",
  notNow: "Not now, thanks",
  match: "MATCH WITH A.I.",

  //Modal date
  dateTitle: "Want to check out our new app?",

  dateBody: `Want to chat with naughty 😈 bots and practice your flirting? You're going to have fun!🔥`,
  goToDate: "Try Date.AI Now!",
  goodForU: "WAS IT GOOD FOR YOU?",
  rateOurPerformance: "Rate our performance so far",
  veryGood: "Very Good",
  veryBad: "Very Bad",

  feedbackChallenge:
    "What would make you share the Hot Challenges app with other couples and why?",
  type: "Type your answer here...",
  survey: "Satisfaction survey.",
  shareIfConfortable: `Feel free to share with friends if you're comfortable :)`,

  howToPlay: "How to Play",
  howToPlayHotChallenge:
    "Get ready to spice things up! Draw a challenge card and surprise your partner with some hot action!",

  // Pre game tips
  preGameTip1:
    "Unleash your desires and make unforgettable moments with your partner!",
  preGameTip2:
    "Ignite your passions and create unforgettable moments together!",
  preGameTip3:
    "Explore your wildest desires and craft memories you'll never forget!",
  preGameTip4:
    "Set your fantasies free and indulge in moments of pure pleasure!",

  selecionajoagador: `Time to play`,
  dica: "Tip",
  howToPlayNaughty:
    "Select your favorite toys and objects. Spin the wheel and let fate decide your next naughty challenge!",
  howToPlayTruthOrDare:
    "Pick your fate: share a truth or take on a daring challenge. Let the fun begin!",

  howToKama1: "Discover Pleasure Positions – 365 Days of Passion!",
  howToKama2:
    "Pick a random card, try the position, and explore new heights of pleasure together!",

  kamaExplain:
    "Unlock a new position every day and build your ultimate collection of passion – your journey to 365 days of unforgettable pleasure starts here!",
  howToDo: "How to do",
  pergunta: "Question",

  restart: "Restart",
  dialogText1HotChallenges:
    "You completed all available challenges with the selected categories.",
  dialogText2HotChallenges:
    "Select more categories or restart the game with the current challenges!",
  noChallenges: "No Challenges!",

  objects: "Objects",
  dialogText1NaughtyGames:
    "You completed all available challenges with the selected objects.",
  dialogText2NaughtyGames:
    "Select more objects or restart the game with the current challenges!",

  unlockPremium: "Unlock Premium",

  noCategory: "Please choose at least one category to start.",
  thanksForFeedback: "Thanks for helping us improve the experience!",
  categoryKamasutra: "Pick your passion and play!",
  tap: "Tap to reveal your position!",
  step: "Step-by-Step Guide",
  shareQuizButton: "Share your naughty level!",
  tryAgain: "Try again",
  unlockAllFun: "Unlock All Fun",
  limitedOffer: "Special offer for a limited time!",
  fill: "Enter your name and your partner's name.",
  kamaNotificationTitle: "🔥 Your new card is unlocked!",
  kamaNotificationBody:
    "Your position for day {variavel} is ready. How about trying something new today? 💋",

  titleNewGame: "Get Ready for Roleplay!",
  phraseNewGame:
    "In the next update, a new game to explore your most creative fantasies is coming. Choose characters, create stories, and take fun to a whole new level with your partner. 🔥",
  awaitNewGame: "Stay tuned and get ready to experience unique moments!",

  selectObjects:
    "Select two or more items to customize your game. Explore to the fullest.",
  soon: "Coming Soon",
  wantToBeNotify: "I want to be notified",
  ok: "OK",
  vezDe: "TURN",

  categoryLabel: "Category",
  descriptionLabel: "Description",

  loginConnect: "Login",
  loginNoAccount: "Don't have an account?",
  loginCreateNow: "Create now",
  loginOrConnect: "or connect with",

  email: "Email",
  password: "Password",
  loginRegister: "Register",
  loginAlreadyHas: "Already have an account?",
  enterNow: "Enter Now",

  logout: "Logout",
  customerPortal: "Customer Portal",
  installApp: "Install App",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/ingles.mp4",
};
